module.exports = __webpack_public_path__ + "img/RoomServiceOutlined.f1c2bff7.svg";